import type {ChannelExpandedCommon} from '../../../api/channel';
import type {CoreClientChannelsCreatePrivateParams} from '../../../api/types/core/methods';

import {channelExpandCommon, channelStore} from '../../../api/channel';

type ParamsType = CoreClientChannelsCreatePrivateParams;

export const createChannel = async ({channel_type, user_ids}: ParamsType) => {
  return (await channelStore.create({
    channel_type,
    expand: channelExpandCommon,
    user_ids,
  })) as ChannelExpandedCommon;
};
